import apiFetch from '../apiFetch'

export default function (token, body) {
  const formData = new FormData()
  for (var key in body) {
    formData.append(key, body[key])
  }
  return apiFetch({ endPoint: 'UnattendedProcess/SEPOMEX/Import', method: 'POST', body: formData, fileBody: true, token: token })
}
